// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/.store/css-loader@3.6.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-input--mini .el-input__inner{padding:0 0;text-align:center}", ""]);
// Exports
module.exports = exports;
